import React from "react"

export const Nodea = () => {
    return (
        <>
        Nodea
        Opis/ Zajawka
        film?

        menu
        Historia 
        Świat
            Mapa

        Postacie
            chce, nie chce           
        </>
    )
}

// bagno
// ogniki - małe niebioesko zielone światełka, istnieje legenda, żeby za nimi nie podążać, bo prowadzą do śmierci. ale nie jest to prawda
// czychacz - ogromna żaba zakopująca się w błocie, na czubku jej pyska jest wędka zakończona czymś co przypomina ognika, wabiąc swtorzenia wprost do jej paszczy.

//     wielka pustynia
//     ciernie, wśród nich ciała z powbijanymi w nie kolcami, ciała szepczą i proszą o pomoc przyciągajac innych w płuapkę.
//      psyroth - małe słodkie zwierzeta, które potrafią przejmowac kontrolę nad umysłem, oczami.

// Postać Sol, 
// 